import React from 'react';
export const Recovery: React.FC<{ onRecovery: () => void }> = ({ onRecovery }) => {
  return (
    <div className="gen-file-viewer__controls">
      <span className="gen-file-viewer__errormessage">Image has failed to load</span>
      <div className="gen-file-viewer__controls-button-group">
        <div
          className="gen-file-viewer__controls-button gen-file-viewer__controls-button-text"
          onClick={onRecovery}
        >
          <span>Retry</span>
        </div>
      </div>
    </div>
  );
};
